import {useCallback} from "react";

import type {KeenSliderInstance} from "keen-slider";

type ReturnHook = {handlePrev: () => void; handleNext: () => void; handleGoTo: (index: number) => void};
export function useSliderNavigation(sliderInstance: KeenSliderInstance | null, videosCount: number): ReturnHook {
    const handlePrev = useCallback((): void => {
        sliderInstance?.prev();
    }, [sliderInstance]);

    const handleNext = useCallback((): void => {
        sliderInstance?.next();
    }, [sliderInstance]);

    const handleGoTo = useCallback(
        (index: number): void => {
            if (index >= 0 && index < videosCount) {
                sliderInstance?.moveToIdx(index);
            }
        },
        [sliderInstance, videosCount],
    );

    return {
        handlePrev,
        handleNext,
        handleGoTo,
    };
}
